<template>
  <form
      id="site-search-box"
      :class="formCssClasses"
      :qaid="qaids.form"
      :name="names.form"
      method="GET"
      :action="`${encodedContextPath}/search/`"
      @submit="trimSearchTerm">
    <input
        v-model="searchTerm"
        :qaid="qaids.input"
        :class="inputCssClasses"
        type="text"
        name="text"
        aria-label="site-search"
        spellcheck="false"
        autocorrect="off"
        maxlength="100"
        :placeholder="$t('search.placeholder')"
        :data-options="options"
    />
    <button qaid="search_submit" type="submit" class="search-form-icon search_submit material-icons md-24">search
    </button>
    <button qaid="search_close" type="reset" class="search-form-icon search_close material-icons md-24">close</button>

    <div v-if="showAutocomplete" class="autocomplete-arrow"></div>
  </form>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'SearchInput',

  props: {
    componentUid: {
      type: String,
      required: true
    },
    formCssClasses: {
      type: String,
      required: true
    },
    inputCssClasses: {
      type: String,
      required: true
    },
    options: {
      type: String,
      required: true
    },
    showAutocomplete: {
      type: Boolean,
      default: false,
    },

  },

  data() {
    return {
      searchTerm: '',
    };
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
    autocompleteUrl() {
      return `${this.encodedContextPath}/search/autocomplete/${this.componentUid}`;
    },
    names() {
      return {
        form: `search_form_${this.componentUid}`
      };
    },
    qaids() {
      return {
        form: `search_form_${this.componentUid}`,
        input: `input_${this.componentUid}`,
      };
    }
  },

  methods: {
    trimSearchTerm() {
      this.searchTerm = this.searchTerm.trim();
    },
  },
};
</script>
